module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cip-break"
  }, [_c('a', {
    attrs: {
      "id": "pIV"
    }
  }), _vm._v("Published with assistance from the foundation established in memory of "), _c('br'), _vm._v("Calvin Chapin of the class of 1788, Yale College.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Copyright © 2017 by Mary Graham. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("This book may not be reproduced, in whole or in part, including illustrations, "), _c('br'), _vm._v("in any form (beyond that copying permitted by Sections 107 and 108 of the "), _c('br'), _vm._v("U.S. Copyright Law and except by reviewers for the public press), "), _c('br'), _vm._v("without written permission from the publishers.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Yale University Press books may be purchased in quantity for educational, "), _c('br'), _vm._v("business, or promotional use. For information, please e-mail "), _c('a', {
    attrs: {
      "href": "mailto:sales.press@yale.edu"
    }
  }, [_vm._v("sales.press@yale.edu")]), _vm._v(" "), _c('br'), _vm._v("(U.S. office) or "), _c('a', {
    attrs: {
      "href": "mailto:sales@yaleup.co.uk"
    }
  }, [_vm._v("sales@yaleup.co.uk")]), _vm._v(" (U.K. office).")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Set in Time Roman type by IDS Infotech Ltd., Chandigarh, India.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Printed in the United States of America.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("ISBN 978-0-300-22374-3")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Library of Congress Control Number 2016950309")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("A catalogue record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("This paper meets the requirements of ANSI/NISO Z39.48-1992 "), _c('br'), _vm._v("(Permanence of Paper).")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("10  9  8  7  6  5  4  3  2  1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8673887c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyright.vue
// module id = 63
// module chunks = 0